import Model from 'flarum/common/Model';

export default class EngineVersion extends Model {
  name() {
    return Model.attribute<string>('name').call(this);
  }

  slug() {
    return Model.attribute<string>('slug').call(this);
  }

  color() {
    return Model.attribute<string>('color').call(this);
  }

  position() {
    return Model.attribute<number>('position').call(this);
  }

  isActive() {
    return Model.attribute<boolean>('isActive').call(this);
  }
}
